import { render, staticRenderFns } from "./SlidersNewOrEdit.vue?vue&type=template&id=bdb82d1c&scoped=true&"
import script from "./SlidersNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./SlidersNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./SlidersNewOrEdit.vue?vue&type=style&index=0&id=bdb82d1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb82d1c",
  null
  
)

export default component.exports